import { useNavigate, useMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Button } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import WorkIcon from "@mui/icons-material/Work";

function AdminButton() {
    const { user } = useSelector((state) => state.auth);
    const isAdmin = user?.is_admin === true;
    const isAdminArea = useMatch("/admin/*");
    const navigate = useNavigate();

    const handleClickAdminButton = () => navigate("/admin");
    const handleClickWorkspaceButton = () => navigate("/workspace");

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            {isAdminArea && (
                <Button startIcon={<WorkIcon />} onClick={handleClickWorkspaceButton}>
                    Workspace
                </Button>
            )}

            {!isAdminArea && isAdmin && (
                <Button color="warning" startIcon={<BuildIcon />} onClick={handleClickAdminButton}>
                    Admin
                </Button>
            )}
        </Box>
    );
}

export default AdminButton;
